export { default } from "./ChangePasswordForm"


// WEBPACK FOOTER //
// ./src/components/UserDetails/ChangePasswordForm/index.ts